import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { MainLayoutComponent } from "./shared/layout/app-layouts/main-layout.component"; 


const routes: Routes = [
    {
        path: '',
        component: MainLayoutComponent,
        children: [
            // {
                // TODO
                // redirectTo: 'dashboard-financeiro' 
                // path: '', redirectTo: 'dashboard-financeiro/financeiro', pathMatch: 'full',
                // data: {
                    // name: 'Início',
                // }
            // },
            {
                // TODO
                // redirectTo: 'dashboard-financeiro' 
                path: '', redirectTo: 'dashboard-tribunal/tribunal', pathMatch: 'full',
                data: {
                    name: 'Início',
                }
            },
            {
                path: 'dashboard-tribunal',
                loadChildren: '@app/+modules/tribunal/tribunal-dashboard/tribunal-dashboard.module#TribunalDashboardModule' ,
                data: {
                    name: 'Dashboard tribunal',
                }
            }
        ]
    },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})], // ,  enableTracing: true
  exports: [RouterModule]
})
export class AppRoutingModule {}
